export default "__VITE_ASSET__d6a3f440__"